import { EVENTS, type EventName } from '@/utils/analyticsEvents';

export type PreferenceField = 'notification_enabled' | 'share_usage_data';

export const resolveHistoryArchiveEventName = (isArchived: boolean): EventName => {
  return isArchived ? EVENTS.HISTORY_RECORD_UNARCHIVED : EVENTS.HISTORY_RECORD_ARCHIVED;
};

export const resolvePreferenceEventName = (field: PreferenceField): EventName => {
  return field === 'notification_enabled' ? EVENTS.NOTIFICATION_SETTING_CHANGED : EVENTS.PRIVACY_SETTING_CHANGED;
};
